import { useParams } from "react-router-dom";

// User brought here from a redirect.
// This is where the first user submission takes place.
// If there is no existing projects for this visiting customer, they will submit their form and a new project will be created.
// Only one existing project can be in progress at a time for a customer. There can be many failed / denied projects.
const NodePage: React.FC = () => {
    const artistId = useParams<string>();


  return (
    <div>
      <h1>Node Details</h1>
      {/* Add more details about the node here */}
    </div>
  );
}

export default NodePage;
